import { store } from '../../store'
import { plainToClass } from 'class-transformer'
import { GetCourseStatsDTO } from '../../dto/courses'
import { validate } from 'class-validator'

export const getStats = async () => {

    let body, response

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/cms/courses/stats`, {
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'GET'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'GET_COURSE_STATS_TIMEOUT' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'GET_COURSE_STATS_UNAUTHORIZED' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'GET_COURSE_STATS_UNEXPECTEDRESPONSE' } )
        return

    }

    try {

        body = plainToClass( GetCourseStatsDTO, JSON.parse( await response.text() ) )

    } catch ( exception ) {

        store.dispatch( { type: 'GET_COURSE_STATS_INVALIDJSON' } )
        return

    }

    if ( ( await validate( body ) ).length > 0 ) {

        store.dispatch( { type: 'GET_COURSE_STATS_INVALIDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'GET_COURSE_STATS_OK', stats: body } )

}